import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class LoaderService {
	private _isLoading = new BehaviorSubject<boolean>(false)
	private readonly defaultSource = Symbol('default-loader')
	private readonly sources = new Set<symbol>()
	isLoading$ = this._isLoading.asObservable()

	// Muestra el loader
	showLoading(source: symbol = this.defaultSource) {
		this.sources.add(source)
		this._isLoading.next(true)
	}

	// Oculta el loader
	hideLoading(source: symbol = this.defaultSource) {
		this.sources.delete(source)
		this._isLoading.next(this.sources.size > 0)
	}
}
